module.exports = __webpack_public_path__ + "img/2.909837ad.png";